export default __webpack_public_path__ + "static/media/utility3.cf53ac78.svg";